import React, { memo } from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock, Zap, Check } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
const BASE_URL = 'https://checkout.kitonline.shop/cart/48009202860270:1';
const PREMIUM_URL = 'https://checkout.kitonline.shop/cart/48009207054574:1';
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-4 py-7 px-4 bg-brand-cream" data-id="element-157">
      <div className="max-w-6xl mx-auto" data-id="element-158">
        <div className="text-center mb-5" data-id="element-159">
          <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-160">
            Elegí el plan que{' '}
            <span className="green-highlight" data-id="element-161">mejor se adapta a vos:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-162">
          {/* BASE */}
          <div className="brunson-card rounded-xl p-4 md:p-6 flex flex-col relative" data-id="element-163">
            <div className="text-center mb-3" data-id="element-164">
              <p className="text-brand-green font-display font-bold uppercase text-xs tracking-widest" data-id="element-165">
                ✅ Opción Base
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-166">
                Sistema Acuicultura Pro™
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-167">
                Todo lo que necesitás para transformar tus clases
              </p>
            </div>

            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-168">
              {['6 Tomos Maestros (500+ páginas)', '4 Bonos Estratégicos (Actividades, Exámenes, Proyectos, Planificación)', 'Actualizaciones de por vida'].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-169">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-green shrink-0 mt-0.5" strokeWidth={3} data-id="element-170" />
                  <span className="text-sm md:text-base text-brand-ink font-medium" data-id="element-171">
                    {f}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-creamAlt rounded-lg p-3 text-center mb-3 border border-brand-line" data-id="element-172">
              <p className="font-display text-3xl md:text-5xl font-bold text-brand-orange leading-none" data-id="element-173">
                🔥 ARS $21.990
              </p>
              <p className="text-[11px] text-brand-mute font-medium mt-1" data-id="element-174">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <Button href={BASE_URL} data-id="element-175">
              🚀 Sí, Quiero el Sistema Acuicultura Pro
            </Button>
            <Trust data-id="element-176" />
          </div>

          {/* PREMIUM */}
          <div className="bg-white rounded-xl p-4 md:p-6 flex flex-col relative border-[3px] border-brand-green shadow-[0_8px_0_#1A365D,0_12px_32px_rgba(26,54,93,0.22)]" data-id="element-177">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white font-display font-bold text-xs md:text-sm tracking-widest px-4 py-1.5 rounded-full uppercase border-2 border-white whitespace-nowrap shadow-md" data-id="element-178">
              🏅 Elección de los Expertos
            </div>

            <div className="text-center mb-3 mt-2" data-id="element-179">
              <p className="text-brand-green font-display font-bold uppercase text-xs tracking-widest" data-id="element-180">
                ⭐ Pack Premium
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-181">
                Sistema + Mega Banco Acuícola Pro
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-182">
                Para el docente que busca el máximo nivel
              </p>
            </div>

            <p className="text-xs md:text-sm text-brand-ink font-bold mb-2 uppercase tracking-wide" data-id="element-183">
              Todo lo anterior, más 💎 Mega Banco Acuícola Pro — El Arsenal de
              Élite:
            </p>
            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-184">
              {[{
              t: 'Simulaciones de Crisis:',
              d: 'El aula simula la granja real bajo presión.'
            }, {
              t: 'Dossiers de Granjas:',
              d: 'Datos reales de producción para alumnos que piensen como gerentes.'
            }, {
              t: '100 Preguntas Élite:',
              d: 'Razonamiento profesional (no memoria).'
            }, {
              t: 'Desafíos Extremos:',
              d: 'Soluciones creativas a límites de presupuesto y biología.'
            }, {
              t: '20 Casos Reales:',
              d: 'Crisis históricas y transformaciones tecnológicas.'
            }].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-185">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-green shrink-0 mt-0.5" strokeWidth={3} data-id="element-186" />
                  <span className="text-sm md:text-base text-brand-ink leading-snug" data-id="element-187">
                    <span className="font-bold" data-id="element-188">{f.t}</span> {f.d}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-greenSoft rounded-lg p-3 text-center mb-3 border border-brand-green" data-id="element-189">
              <p className="font-display text-3xl md:text-5xl font-bold text-brand-orange leading-none" data-id="element-190">
                🔥 ARS $29.990
              </p>
              <p className="text-[11px] text-brand-navy font-bold mt-1" data-id="element-191">
                Pago único · Acceso inmediato a todo
              </p>
            </div>

            <Button href={PREMIUM_URL} data-id="element-192">
              🚀 Sí, Quiero el Pack Premium + Mega Banco Pro
            </Button>
            <Trust data-id="element-193" />
          </div>
        </div>
      </div>
    </section>;
}
function Trust() {
  return <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-3 text-[10px] md:text-xs font-bold text-brand-navy uppercase tracking-wide" data-id="element-194">
      <div className="flex items-center" data-id="element-195">
        <Lock className="w-3 h-3 mr-1 text-brand-green" data-id="element-196" /> Pagá con Mercado Pago
      </div>
      <div className="flex items-center" data-id="element-197">
        <Zap className="w-3 h-3 mr-1 text-brand-green" data-id="element-198" /> Acceso 5 min
      </div>
      <div className="flex items-center" data-id="element-199">
        <ShieldCheck className="w-3 h-3 mr-1 text-brand-green" data-id="element-200" /> Garantía 7
        días
      </div>
    </div>;
}